import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { map } from 'rxjs/operators';

import { WorkspaceRecordService } from './workspace-record.service';

/**
 * Holds navigation until the workspace record is in memory.
 *
 * `@semeris/workspace-ui` screens gate on `WORKSPACE_CONTEXT.active()`, and the documents
 * screen reads `libraryIds` from it *synchronously in its constructor* to validate the
 * URL's library id — so a screen entered before the record lands silently discards its
 * deep link. Fail-open: a missing workspace, a failed fetch and a slow one all resolve.
 */
export const workspaceRecordResolver: ResolveFn<boolean> = () =>
  inject(WorkspaceRecordService)
    .whenLoaded()
    .pipe(map(() => true));
